import { Action } from 'redux';
import { Group } from '../../clients/aasServerClient.generated';

export enum ActionTypeNames {
    ImportXML = 'Database/ImportXML',
    UpdateImportProgress = 'Database/UpdateImportProgress',
    ImportSuccess = 'Database/ImportSuccess',
    ImportError = 'Database/ImportError',
    ClearImportStatus = 'Database/ClearImportStatus',
}

export type ImportXMLAction = Action<ActionTypeNames.ImportXML> & {
    hostname: string;
    secure: boolean;
    workspaceId: string;
    formData: FormData;
};

export type UpdateImportProgressAction = Action<ActionTypeNames.UpdateImportProgress> & {
    text: string;
    progress: number;
};

export type ImportSuccessAction = Action<ActionTypeNames.ImportSuccess> & { key?: string };
export type ImportErrorAction = Action<ActionTypeNames.ImportError> & { error: Error };
export type ClearImportStatusAction = Action<ActionTypeNames.ClearImportStatus>;
